import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

export const infiniteScrollStyle: CSSProperties = {
  height: 'auto',
  overflow: 'initial',
  position: 'relative',
  paddingBottom: 40,
};

interface StyledDivProps {
  children?: ReactNode;
  id?: string;
}

export const WrapperTable = styled.div<StyledDivProps>`
  display: block;
  max-width: 100%;

  table {
    width: 100%;
    border-spacing: 0;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th,
    td {
      margin: 0;
      padding: 12px;
      border-bottom: ${({ theme }) => `1px solid ${theme.palette.tableBorderColorLight}`};
      border-right: ${({ theme }) => `1px solid ${theme.palette.tableBorderColorLight}`};
      width: 1%;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

export const TableWrap = styled.div<StyledDivProps>`
  display: block;
  max-width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
`;

interface TableProps {
  children?: ReactNode;
}

export const Table = styled.table<TableProps>``;

export const TableBody = styled.tbody<TableProps>``;

export const NoRecordsFound = styled.p<StyledDivProps>`
  padding: 30px;
  margin: auto;
  text-align: center;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
`;

export const TableHeight = styled.div<StyledDivProps>`
  min-height: 650px;
  height: 1px;
  overflow: auto;
`;
